import { makeStyles } from "@material-ui/styles";
import { fade } from "@material-ui/core/styles/colorManipulator";

export default makeStyles(theme => ({
  logotype: {
    color: "white",
    marginLeft: theme.spacing(2.5),
    marginRight: theme.spacing(2.5),
    fontWeight: 500,
    fontSize: 18,
    whiteSpace: "nowrap",
    [theme.breakpoints.down("xs")]: {
      display: "none",
    },
  },
  appBar: {
    // AppBar renders a <header>; pin padding so stray global `header {}` CSS can't shift it.
    padding: 0,
    width: "100vw",
    zIndex: theme.zIndex.drawer + 1,
    backgroundColor: "#f5f5f5",
    boxShadow: "none",
    borderBottom: "none",
    transition: theme.transitions.create(["margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  toolbar: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    position: "relative",
    minHeight: 60,
    height: 60,
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
      minHeight: 56,
      height: 56,
    },
  },
  navIconButton: {
    color: "#1a1a1a",
    borderRadius: 10,
    "&:hover": {
      backgroundColor: "#e6e6e6",
    },
  },
  navLink: {
    color: "#1a1a1a",
    fontSize: 15,
    fontWeight: 500,
    padding: "6px 10px",
    borderRadius: 8,
    transition: "background-color .15s ease, color .15s ease",
    "&:hover": {
      backgroundColor: "#f1f5fb",
      color: "#0b5cc2",
    },
  },
  parentSchoolBtn: {
    backgroundColor: "#1769d6",
    color: "#fff",
    textTransform: "none",
    fontWeight: 600,
    borderRadius: 8,
    padding: "6px 12px",
    marginRight: theme.spacing(1),
    boxShadow: "0 4px 10px rgba(23,105,214,0.2)",
    whiteSpace: "nowrap",
    "&:hover": { backgroundColor: "#125bbd" },
    [theme.breakpoints.down("xs")]: {
      minWidth: 0,
      padding: "6px 8px",
      fontSize: 12,
    },
  },
  centerSchoolBrand: {
    position: "absolute",
    left: "50%",
    transform: "translateX(-50%)",
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
    // Leave room for logo (left) and About / Upgrade / icons (right) so the name never overlaps them.
    maxWidth: "max(160px, calc(100vw - 2 * 460px))",
    pointerEvents: "none",
    [theme.breakpoints.down("sm")]: {
      maxWidth: "min(56vw, 520px)",
      gap: theme.spacing(1),
    },
  },
  centerSchoolLogo: {
    width: 34,
    height: 34,
    objectFit: "contain",
    borderRadius: 6,
    flexShrink: 0,
    backgroundColor: "#fff",
    [theme.breakpoints.down("sm")]: {
      width: 28,
      height: 28,
    },
  },
  centerSchoolName: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    color: "#1a1a1a",
    fontWeight: 600,
    fontSize: 20,
    lineHeight: 1.2,
    [theme.breakpoints.down("sm")]: {
      fontSize: 16,
    },
  },
  hide: {
    display: "none",
  },
  grow: {
    flexGrow: 1,
  },
  search: {
    position: "relative",
    borderRadius: 25,
    paddingLeft: theme.spacing(2.5),
    width: 36,
    backgroundColor: fade(theme.palette.common.black, 0),
    transition: theme.transitions.create(["background-color", "width"]),
    "&:hover": {
      cursor: "pointer",
      backgroundColor: fade(theme.palette.common.black, 0.08),
    },
  },
  searchFocused: {
    backgroundColor: fade(theme.palette.common.black, 0.08),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: 250,
    },
  },
  searchIcon: {
    width: 36,
    right: 0,
    height: "100%",
    position: "absolute",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: theme.transitions.create("right"),
    "&:hover": {
      cursor: "pointer",
    },
  },
  searchIconOpened: {
    right: theme.spacing(1.25),
  },
  inputRoot: {
    color: "inherit",
    width: "100%",
  },
  inputInput: {
    height: 36,
    padding: 0,
    paddingRight: 36 + theme.spacing(1.25),
    width: "100%",
  },
  messageContent: {
    display: "flex",
    flexDirection: "column",
  },
  headerMenu: {
    marginTop: theme.spacing(7),
  },
  headerMenuList: {
    display: "flex",
    flexDirection: "column",
  },
  headerMenuItem: {
    "&:hover, &:focus": {
      backgroundColor: theme.palette.background.light,
      // color: "white",
    },
  },
  // 40px square icon buttons (20px icons), even 4px gap between them.
  headerMenuButton: {
    width: 40,
    height: 40,
    padding: 0,
    marginLeft: theme.spacing(0.5),
    borderRadius: 8,
    flexShrink: 0,
    "&:hover": { backgroundColor: "#e6e6e6" },
    [theme.breakpoints.down("sm")]: {
      width: 36,
      height: 36,
    },
  },
  headerIconButton: {
    width: 40,
    height: 40,
    padding: 0,
    borderRadius: 8,
    marginRight: theme.spacing(0.5),
    "&:hover": { backgroundColor: "#e6e6e6" },
  },
  headerMenuButtonSandwich: {
    marginLeft: 9,
    [theme.breakpoints.down("sm")]: {
      marginLeft: 0
    },
    padding: theme.spacing(0.5),
  },
  headerMenuButtonCollapse: {
    marginRight: theme.spacing(2),
  },
  headerIcon: {
    fontSize: 28,
    color: "rgba(255, 255, 255, 0.35)",
    [theme.breakpoints.down("sm")]: {
      fontSize: 24,
    },
  },
  headerIconCollapse: {
    color: "white",
  },
  profileMenu: {
    minWidth: 265,
  },
  profileMenuUser: {
    display: "flex",
    flexDirection: "column",
    padding: theme.spacing(2),
  },
  profileMenuItem: {
    color: theme.palette.text.hint,
  },
  profileMenuIcon: {
    marginRight: theme.spacing(2),
    color: theme.palette.text.hint,
    '&:hover': {
      color: theme.palette.primary.main,
    }
  },
  profileMenuLink: {
    fontSize: 16,
    textDecoration: "none",
    "&:hover": {
      cursor: "pointer",
    },
  },
  messageNotification: {
    height: "auto",
    display: "flex",
    alignItems: "center",
    "&:hover, &:focus": {
      backgroundColor: theme.palette.background.light,
    },
  },
  messageNotificationSide: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginRight: theme.spacing(2),
  },
  messageNotificationBodySide: {
    alignItems: "flex-start",
    marginRight: 0,
  },
  sendMessageButton: {
    margin: theme.spacing(4),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    textTransform: "none",
  },
  sendButtonIcon: {
    marginLeft: theme.spacing(2),
  },
  purchaseBtn: {
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    },
    marginRight: theme.spacing(3)
  },
  upgradePlanBtn: {
    textTransform: 'none',
    fontWeight: 600,
    height: 36,
    padding: '0 16px',
    marginRight: theme.spacing(1),
    backgroundColor: '#121212',
    borderRadius: 999,
    color: '#fff',
    boxShadow: 'none',
    whiteSpace: 'nowrap',
    '&:hover': {
      backgroundColor: '#333',
      boxShadow: 'none',
    },
  },
  // Black 40px account circle (36px on phones), always visible.
  profileMenuButton: {
    width: 40,
    height: 40,
    padding: 0,
    marginLeft: theme.spacing(1),
    flexShrink: 0,
    backgroundColor: '#121212',
    '&:hover': { backgroundColor: '#333' },
    [theme.breakpoints.down('sm')]: {
      display: 'flex !important',
      width: 36,
      height: 36,
      marginLeft: theme.spacing(0.5),
    },
  }
}));
